import { render, staticRenderFns } from "./DiscoveryEmpty.vue?vue&type=template&id=eeedcd12&scoped=true"
import script from "./DiscoveryEmpty.vue?vue&type=script&lang=js"
export * from "./DiscoveryEmpty.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryEmpty.vue?vue&type=style&index=0&id=eeedcd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeedcd12",
  null
  
)

export default component.exports